var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 13 0.5ZM14.1 20.2V20.65C14.1 21.25 13.6125 21.75 13 21.75C12.4 21.75 11.9 21.2625 11.9 20.65V20.125C11.1125 19.9375 9.4875 19.3625 8.5375 17.5C8.25 16.95 8.525 16.2625 9.1 16.025L9.1875 15.9875C9.7 15.775 10.275 15.9875 10.5375 16.475C10.9375 17.2375 11.725 18.1875 13.1875 18.1875C14.35 18.1875 15.6625 17.5875 15.6625 16.175C15.6625 14.975 14.7875 14.35 12.8125 13.6375C11.4375 13.15 8.625 12.35 8.625 9.5C8.625 9.375 8.6375 6.5 11.9 5.8V5.35C11.9 4.7375 12.4 4.25 13 4.25C13.6 4.25 14.1 4.7375 14.1 5.35V5.8125C15.4375 6.05 16.2875 6.7625 16.8 7.4375C17.225 7.9875 17 8.7875 16.35 9.0625C15.9 9.25 15.375 9.1 15.075 8.7125C14.725 8.2375 14.1 7.75 13.075 7.75C12.2 7.75 10.8125 8.2125 10.8125 9.4875C10.8125 10.675 11.8875 11.125 14.1125 11.8625C17.1125 12.9 17.875 14.425 17.875 16.175C17.875 19.4625 14.75 20.0875 14.1 20.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentPayment);
export default __webpack_public_path__ + "static/media/rent_payment.f4ab392db9e245fc796b411ec72b3ed5.svg";
export { ForwardRef as ReactComponent };